import { useState, useEffect, useCallback, useMemo } from 'react';

// const log = console.log.bind(console, '[useAnalyticsOptOut]');
const log = (...args: any[]) => {}; // silence useAnalyticsOptOut logs

export function useAnalyticsOptOut() {
  const [visible, setVisible] = useState(false);
  const [optedOut, setOptedOut] = useState(false);

  useEffect(() => {
    let isMounted = true;
    async function fetchStatus() {
      if (!window.$gaWidget) return;
      const gaStatus = await window.$gaWidget.getGaStatus();
      log('gaStatus', gaStatus);
      if (isMounted) {
        setOptedOut(!gaStatus.ga_enabled);
        const analyticsOptOutShow = localStorage.getItem('analyticsOptOutShow');
        if (analyticsOptOutShow === 'true') {
          setVisible(true);
        }
        // Optionally, keep the debug log
        log('analyticsOptOutShow', {
          analyticsOptOutShow,
          visible: true,
          optedOut: !gaStatus.ga_enabled,
        });
      }
    }
    fetchStatus();
    return () => {
      isMounted = false;
    };
  }, []);

  // Listen for localStorage changes to sync state across components
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'analyticsOptOutShow') {
        const newValue = e.newValue === 'true';
        log('storage change detected:', newValue);
        setVisible(newValue);
      }
    };

    const handleCustomStorageChange = (e: CustomEvent) => {
      if (e.detail.key === 'analyticsOptOutShow') {
        const newValue = e.detail.value === 'true';
        log('custom storage change detected:', newValue);
        setVisible(newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('localStorageChange', handleCustomStorageChange as EventListener);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageChange', handleCustomStorageChange as EventListener);
    };
  }, []);

  const toggleOptOut = useCallback(async () => {
    log('toggleOptOut', optedOut)
    if (!window.$gaWidget) return;
    if (optedOut) {
      await window.$gaWidget.enable();
    } else {
      await window.$gaWidget.disable();
    }
    setOptedOut((prev: boolean) => !prev);
    window.location.reload();
  }, [optedOut]);

  // install global function to toggle the analytics opt out
  const toggleWidget = useCallback(() => {
    const show = localStorage.getItem('analyticsOptOutShow') || 'false';
    log(`toggleWidget show`, show)
    if (show === 'true') {
      localStorage.setItem('analyticsOptOutShow', 'false');
      setVisible(false);
      // Dispatch custom event for other components
      window.dispatchEvent(new CustomEvent('localStorageChange', {
        detail: { key: 'analyticsOptOutShow', value: 'false' }
      }));
    } else {
      localStorage.setItem('analyticsOptOutShow', 'true');
      setVisible(true);
      // Dispatch custom event for other components
      window.dispatchEvent(new CustomEvent('localStorageChange', {
        detail: { key: 'analyticsOptOutShow', value: 'true' }
      }));
    }
  }, []);

  const _export = useMemo(() => ({
    visible,
    optedOut,
    toggleOptOut,
    toggleWidget,
  }), [visible, optedOut, toggleOptOut, toggleWidget]);

  return _export;
}
